<template>
<div class="footer">
  <div class="footer-wrap">
      <ul class="col-xs-12 col-sm-12 col-md-6">
        <li>联系我们</li>
        <li>
          <div class="footer-info flex-start">
            <!-- <span>总机：9999-99999999</span>
            <span>合作：9999-99999999</span> -->
            <span>电话：029-89568081</span>
            <span>Email：service@weixinbang.com.cn</span>
            <span>地址：长沙市雨花区韶山中路489号万博汇名邸3栋</span>
          </div>
          <!-- 总机：9999-99999999
          &nbsp;&nbsp;&nbsp;
          &nbsp;&nbsp;&nbsp;
          合作：9999-99999999
          &nbsp;&nbsp;&nbsp;
          &nbsp;&nbsp;&nbsp;
          客服：4000-99999999 -->
        </li>
        <!-- <li>
          Email：xxxx@xxx.com
          &nbsp;&nbsp;&nbsp;
          &nbsp;&nbsp;&nbsp;
          地址：xxxxxxxxx
        </li> -->
      </ul>
      <div class="footer-wrap-list col-xs-12 col-sm-12 col-md-4">
        <div>
          <img src="../assets/1571208580.png" alt="">
          <p>APP下载</p>
        </div>
        <div @click="toHotel()">
          <img src="../assets/untitled-20.png" alt="" style="cursor: pointer">
          <p style="cursor: pointer">酒店</p>
        </div>
        <div @click="toKeeperauth()">
          <img src="../assets/untitled-21.png" alt="" style="cursor: pointer">
          <p style="cursor: pointer">人力服务公司</p>
        </div>
      </div>
  </div>
  <div class="footer-details">
    <router-link  to="/pages/About" tag="a"><div>关于我们</div></router-link>
    <router-link  to="/pages/Join" tag="a"><div>加入我们</div></router-link>
    <a href="https://admin.weixinbang.com.cn/#/login"  target="_blank"><div>商户登录</div></a>
  </div>
  <div class="flex-center" style="width:100%;margin:0 auto;padding:10px 0;">
    <a href="https://beian.miit.gov.cn"   target="_blank"><p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#fff;">湘ICP备19027953号-1</p></a>
    <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=43011102001850" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;margin-left: 20px;"><img src="../assets/备案图标.png" style="float:left;"/><p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#fff;">湘公网安备 43011102001850号</p></a>
  </div>
</div>
</template>

<script>
    export default {
        name: "IndexFooter",
        data() {
            return {}
        },
        methods: {
          toHotel(){
            // this.$router.push({ path:'http://hk.finewe.com.cn/#/hotelauth'});
            window.location.href = 'https://admin.weixinbang.com.cn/#/hotelauth';
          },
          toKeeperauth(){
            window.location.href = 'https://admin.weixinbang.com.cn/#/keeperauth';
          },
        }
    }
</script>

<style lang="scss" scoped>
  @import '../assets/scss/index.scss';
  a{
    text-decoration:none;
  }
  .col-xs-12 .col-sm-12 .col-md-6{
    padding: 0;
  }
  .footer{
    width: 100%;
    // height: 200px;
    background: #ff6d1d;
  }
  .footer-info{
    width: 100%;
    span{
      display: block;
      margin-right: 20px;
      margin-top: 5px;
    }
  }
  .footer-wrap{
    @include flex(center);
    // @include px2rem(width, 1300);
    margin: 0 auto;
    @include px2rem(padding-top, 30);
    box-sizing: border-box;
    // justify-content: space-between
    ul{
      li{
        display: block;
        text-align: left;
        @include px2rem(line-height, 30);
        @include px2rem(font-size, 20);
        color:#fff;
      }
    }
  }
  .footer-wrap-list{
    // @include px2rem(width, 400);
    @include flex(space-between);
    p{
      @include px2rem(font-size, 20);
      color:#fff;
    }
    img{
      @include px2rem(margin-top, 10);
      @include px2rem(width, 100);
    }
  }
  .footer-details{
    @include px2rem(margin-top, 10);
    @include flex(center);
    div{
      padding: 0 10px;
      color:#fff;
    }
    div:nth-child(1){
      border-right: 1px solid #fff;
    }
    div:nth-child(2){
      border-right: 1px solid #fff;
    }
  }
  .footer-Filing{
    margin: 0;
    color: #fff;
    @include px2rem(margin-top, 10);
    @include px2rem(font-size, 20);
  }
</style>



// WEBPACK FOOTER //
// src/components/IndexFooter.vue